import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

interface BackButtonProps {
  /** Extra spacing for the screen it sits on. */
  className?: string;
}

/**
 * Takes the user one step back through the auth flow.
 *
 * It walks history rather than naming a route, because the screens it sits on
 * are reached from more than one place - the OTP screen follows the log-in
 * screen on one flow and the consent screen on the other, and only history
 * knows which. Going back that way also restores the router state the previous
 * screen was rendered with, which a fresh navigation would drop.
 */
const BackButton: React.FC<BackButtonProps> = ({ className = "" }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate(-1)}
      className={`inline-flex items-center gap-1.5 text-[14px] text-[#62636C] hover:text-[#1E1F24] transition-colors ${className}`}
    >
      <ArrowLeft className="w-4 h-4" aria-hidden />
      Back
    </button>
  );
};

export default BackButton;
